<template>
    <div class="weChat">
        <div class="loginNum" v-if="mobile">当前登录账号：<span>{{mobile}}</span></div>
        <div class="loginWeChat loginNum">当前绑定微信：<span>{{is_bind_wechat?'已绑定':'未绑定'}}</span></div>
        <div class="webChatTip">温馨提示：考虑您的账号安全，微信号绑定请前往幼聘网小程序操作;小程序操作流程：[我的-设置-账号与安全-微信绑定]</div>
        <div class="goWechat">{{is_bind_wechat?'解绑':'绑定'}}微信：<img class="weChatCode" :src="weChatCode" alt=""></div>
    </div>
</template>

<script>
    import { getWeChatCode } from '@/js/common.js'
    export default {
        data() {
            return {
                mobile: '',
                is_bind_wechat: 0,
                weChatCode: ''
            }
        },
        mounted() {
            let members = JSON.parse(this.Cookies.get('members'))
            let bind = JSON.parse(sessionStorage.getItem('bind'))
            if(members.mobile) {
                this.mobile = members.mobile
            } else {
                this.mobile = '未绑定'
            }
            if(bind.is_bind_wechat) {
                this.is_bind_wechat = bind.is_bind_wechat
            }
            getWeChatCode(this, 'accountNumber/pages/index/accountNumber', '1')
        }
    }
</script>

<style lang="scss" scoped>
.weChat {
    .loginNum {
        padding: 0 30px;
        height: 80px;
        line-height: 80px;
        font-size: 14px;
    }
    .loginWeChat {
        border-top: 1px solid #f2f2f2;
    }
    .webChatTip {
        padding: 0 30px;
        height: 44px;
        background: #f8f8f8;
        line-height: 44px;
        font-size: 14px;
        color: #555;
    }
    .goWechat {
        padding: 0 30px;
        padding-top: 20px;
        font-size: 14px;
        .weChatCode {
            width: 150px;
            vertical-align: middle;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/weChatNum/index.vue